import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ReservationStatusBadge } from '@/modules/reservations/components';
import { listReservationsForItem } from '@/modules/reservations/services';
import type { Reservation } from '@/modules/reservations/types';
import { todayIsoDate } from '@/modules/reservations/utils/dateRange';
import { buildCalendarPath } from '@/modules/calendar/utils';
import { addDays } from '@/modules/calendar/utils/dateRanges';
import { modulePaths } from '@/routes/paths';

type ItemUpcomingReservationsProps = {
  itemId: string;
  showCalendarLink?: boolean;
};

export function ItemUpcomingReservations({
  itemId,
  showCalendarLink = true,
}: ItemUpcomingReservationsProps) {
  const [reservations, setReservations] = useState<Reservation[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const today = todayIsoDate();
    const end = addDays(today, 90);
    void listReservationsForItem(itemId, today, end)
      .then((rows) =>
        setReservations(
          rows
            .filter((r) => r.status !== 'cancelled' && r.endDate >= today)
            .slice(0, 5),
        ),
      )
      .catch(() => setReservations([]))
      .finally(() => setLoading(false));
  }, [itemId]);

  if (loading) return <p className="auth-muted">Cargando reservas…</p>;

  return (
    <div className="inventory-panel inventory-panel--hint">
      <div className="inventory-page-header">
        <h2 className="inventory-panel__subtitle">Próximas reservas</h2>
        {showCalendarLink ? (
          <Link
            to={buildCalendarPath({ itemId, view: 'month' })}
            className="auth-button auth-button--secondary inventory-page-header__btn"
          >
            Ver agenda
          </Link>
        ) : null}
      </div>
      {reservations.length === 0 ? (
        <p className="auth-muted">Sin reservas próximas para este artículo.</p>
      ) : (
        <ul className="item-upcoming-reservations">
          {reservations.map((r) => (
            <li key={r.id}>
              <Link to={`${modulePaths.reservations}/${r.id}`}>{r.title}</Link>
              <span className="auth-muted">
                {' '}
                {r.startDate} → {r.endDate}
              </span>
              <ReservationStatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
